import { render, staticRenderFns } from "./DashboardVertical.vue?vue&type=template&id=cd78fd96&scoped=true&"
import script from "./DashboardVertical.vue?vue&type=script&lang=js&"
export * from "./DashboardVertical.vue?vue&type=script&lang=js&"
import style0 from "./DashboardVertical.vue?vue&type=style&index=0&id=cd78fd96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd78fd96",
  null
  
)

export default component.exports